import { Outlet } from "react-router-dom";

import Footer from "../components/Footer";
import Header from "../components/Header";

const BaseLayout = () => {
  return (
    <div className="bg-[#EDF3FF] font-poppins">
      <Header />
      <Outlet />
      <Footer />
    </div>
  );
};

export default BaseLayout;
